import { render, staticRenderFns } from "./quickLink.vue?vue&type=template&id=11b219f5&scoped=true&"
import script from "./quickLink.vue?vue&type=script&lang=js&"
export * from "./quickLink.vue?vue&type=script&lang=js&"
import style0 from "./quickLink.vue?vue&type=style&index=0&id=11b219f5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b219f5",
  null
  
)

export default component.exports